document.addEventListener("DOMContentLoaded", function () {
  var customBtn = document.getElementById("KiwiSizeChartBtn");
  if (!customBtn) return;

  function getKiwiBtn() {
    return document.querySelector(".ks-chart-modal-link");
  }

  // Kiwi can inject late, so retry briefly
  var tries = 0;
  var maxTries = 20; // 20 * 250ms = 5s
  var interval = 250;

  var timer = setInterval(function () {
    tries++;

    var kiwiBtn = getKiwiBtn();

    if (kiwiBtn) {
      // Show your button once Kiwi exists
      customBtn.style.display = "";

      // Bind click once (avoid multiple bindings)
      if (!customBtn.dataset.kiwiBound) {
        customBtn.dataset.kiwiBound = "true";
        customBtn.addEventListener("click", function () {
          var btn = getKiwiBtn();
          if (btn) btn.click();
        });
      }

      clearInterval(timer);
      return;
    }

    // After retries, keep it hidden
    if (tries >= maxTries) {
      customBtn.style.display = "none";
      clearInterval(timer);
    }
  }, interval);
});
